module.exports = __webpack_public_path__ + "images/fce20a85f64b3a724a48f2d8c481ec4e.jpg";